import { render, staticRenderFns } from "./DebugControl.vue?vue&type=template&id=1d3734f6&"
import script from "./DebugControl.vue?vue&type=script&lang=ts&"
export * from "./DebugControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3734f6')) {
      api.createRecord('1d3734f6', component.options)
    } else {
      api.reload('1d3734f6', component.options)
    }
    module.hot.accept("./DebugControl.vue?vue&type=template&id=1d3734f6&", function () {
      api.rerender('1d3734f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/debug/DebugControl.vue"
export default component.exports